import {createTheme, defaultVariantColorsResolver, Modal, parseThemeColor} from "@mantine/core";
import {DatePicker, DatePickerInput, DateTimePicker} from "@mantine/dates";
import { MonthView, WeekView } from "@mantine/schedule";

export const MANTINE_THEME = createTheme({
    components: {
        Modal: Modal.extend({
            vars: (_, modalProps) => {
                if (modalProps.size === "xxl") {
                    return {
                        root: {
                            "--modal-size": "calc(58.75rem * var(--mantine-scale))"
                        }
                    }
                }
                return { root: {} }
            }
        }),
        DatePicker: DatePicker.extend({
            defaultProps: {
                firstDayOfWeek: 0,
                highlightToday: true
            }
        }),
        DatePickerInput: DatePickerInput.extend({
            defaultProps: {
                valueFormat: "MM/DD/YYYY"
            }
        }),
        DateTimePicker: DateTimePicker.extend({
            defaultProps: {
                valueFormat: "MM/DD/YYYY hh:mm A"
            }
        }),
        MonthView: MonthView.extend({
            defaultProps: {
                firstDayOfWeek: 0
            }
        }),
        WeekView: WeekView.extend({
            defaultProps: {
                firstDayOfWeek: 0
            }
        })
    },
    variantColorResolver: (input) => {
        const defaultResolvedColors = defaultVariantColorsResolver(input);
        const parsedColor = parseThemeColor({
            color: input.color || input.theme.primaryColor,
            theme: input.theme,
        });

        // Override some properties for variant
        if (parsedColor.isThemeColor && input.variant === 'subtle' || input.variant === "transparent") {
            return {
                ...defaultResolvedColors,
                color: `var(--mantine-color-${parsedColor.color}-text)`,
            };
        }

        return defaultResolvedColors;
    },
    autoContrast: true,
    luminanceThreshold: 0.4
})